// Base de connaissances complète intégrée depuis le fournisseur d'énergie partenaire.
// Le nom du fournisseur n'apparaît jamais.

export const faqCategories = [
  {
    category: "La formule tout compris",
    items: [
      {
        q: "Que comprend l'offre à 150 € ?",
        a: "Une solution énergétique totale : nous couvrons votre toit de panneaux solaires ET installons une batterie domestique, sans investissement de votre part. Vous ne payez que 150 € de frais de dossier uniques pour l'installation. Tout est compris : installation, contrôle et suivi.",
      },
      {
        q: "Le prix de l'électricité est-il vraiment garanti ?",
        a: "Oui. Votre consommation est facturée à un tarif fixe ultra-compétitif de 0,27 €/kWh, pour l'ensemble de votre énergie, pendant 25 ans. Aucun risque, aucune fluctuation liée au marché.",
      },
      {
        q: "Et l'inflation sur ces 25 ans ?",
        a: "L'inflation appliquée au tarif est plafonnée à maximum 2 % par an. Résultat : la part de votre budget consacrée à l'énergie diminue chaque année.",
      },
      {
        q: "Que se passe-t-il après 25 ans ?",
        a: "Au terme des 25 ans, l'installation (panneaux + batterie) vous appartient entièrement. Vous êtes libre de choisir un nouveau tarif chez nous ou un autre fournisseur. Votre toit, votre décision.",
      },
      {
        q: "Puis-je arrêter avant la fin des 25 ans ?",
        a: "Oui, vous gardez le contrôle. Si vous déménagez ou souhaitez changer de tarif, vous reprenez simplement la valeur résiduelle de votre installation. Pas de pénalités, pas de petits caractères, pas de clauses opaques.",
      },
      {
        q: "Puis-je prendre uniquement des panneaux, ou uniquement une batterie ?",
        a: "Tout est possible : uniquement des panneaux solaires, uniquement une batterie, ou les deux d'emblée. Nous adaptons la solution à vos besoins réels.",
      },
    ],
  },
  {
    category: "Photovoltaïque en Wallonie & Flandre",
    items: [
      {
        q: "Intervenez-vous en Wallonie et en Flandre ?",
        a: "Oui, nous sommes actuellement présents en Wallonie et en Flandre. Une étude gratuite et sans engagement est réalisée à votre domicile.",
      },
      {
        q: "L'installation est-elle certifiée selon les normes belges ?",
        a: "Oui. Chaque installation est contrôlée par un organisme agréé et déclarée conforme au RGIE. Nous prenons en charge toutes les démarches administratives pour vous.",
      },
      {
        q: "Comment fonctionne l'autoconsommation en Wallonie et en Flandre ?",
        a: "Vous consommez en priorité l'électricité produite par vos panneaux solaires. Le surplus est stocké dans la batterie, puis injecté si nécessaire. Vous réduisez fortement votre dépendance au réseau et l'impact du tarif prosumer.",
      },
      {
        q: "Qu'en est-il du tarif prosumer et de mon compteur ?",
        a: "Grâce à la batterie, vous maximisez l'autoconsommation et limitez l'impact du tarif prosommateur appliqué en Wallonie et en Flandre. Nous adaptons l'installation à votre compteur (simple, bi-horaire ou double flux).",
      },
    ],
  },
  {
    category: "Panneaux solaires & batterie",
    items: [
      {
        q: "À quoi sert une batterie domestique ?",
        a: "Vos panneaux produisent de l'électricité toute la journée. La batterie la conserve chez vous pour l'utiliser le soir. Vous consommez davantage de votre propre énergie verte, vous réduisez l'usage en heures de pointe (plus chères) et vous devenez moins dépendant du réseau.",
      },
      {
        q: "Quelle capacité de batterie me faut-il ?",
        a: "Nous dimensionnons la batterie selon votre consommation réelle : 9 kWh pour un ménage de 1 à 3 personnes ; 18 kWh pour 3 à 4 personnes (avec marge pour une borne de recharge ou une pompe à chaleur) ; jusqu'à 54 kWh pour 4 personnes et plus ou les habitations fortement électrifiées.",
      },
      {
        q: "Que se passe-t-il en cas de coupure de courant ?",
        a: "Avec la fonction d'alimentation de secours, votre maison continue de fonctionner normalement : PC, wifi, éclairage… Tout reste allumé même si le réseau tombe en panne.",
      },
      {
        q: "La batterie peut-elle recharger ma voiture électrique ?",
        a: "Oui. Nos appareils combinent batterie, onduleur hybride et une borne de recharge DC (12 kW ou 25 kW) en une seule unité. Recharge plus rapide en courant continu, sans installation séparée.",
      },
      {
        q: "La charge de la batterie est-elle optimisée ?",
        a: "Oui, grâce aux tarifs dynamiques : la batterie se charge quand l'électricité est bon marché et la restitue quand les prix sont plus élevés. Vous reprenez le contrôle de votre facture toute l'année.",
      },
      {
        q: "Les panneaux produisent-ils en hiver ?",
        a: "Oui, ils continuent à produire même en hiver. Cette énergie, vous la gardez et l'exploitez au maximum grâce à la batterie, en gaspillant le minimum.",
      },
      {
        q: "La batterie s'installe-t-elle en intérieur ou en extérieur ?",
        a: "Les deux : nos batteries sont résistantes aux intempéries pour l'extérieur et certifiées pour l'intérieur. La batterie et l'onduleur forment un ensemble compact conçu pour votre habitation.",
      },
    ],
  },
  {
    category: "Prix, facture & économies",
    items: [
      {
        q: "Quel niveau d'autonomie puis-je atteindre ?",
        a: "En moyenne, nos clients couvrent 90 % de leur consommation avec leur propre production. Une énergie locale, tirée du soleil, qui allège le réseau.",
      },
      {
        q: "Que se passe-t-il si je consomme plus que ma production ?",
        a: "Si votre consommation dépasse ce que votre installation produit, nous complétons avec de l'électricité issue d'autres ménages, d'entreprises ou, si nécessaire, du réseau — toujours au même tarif fixe ultra-compétitif.",
      },
      {
        q: "Y a-t-il des frais cachés ?",
        a: "Non. Installation gratuite, prix fixe pendant 25 ans, pas de frais cachés, pas de petits caractères. Ce que vous signez est ce que vous payez.",
      },
    ],
  },
  {
    category: "Installation & démarrage",
    items: [
      {
        q: "Comment se déroule le processus ?",
        a: "En 4 étapes : 1) Un entretien de découverte gratuit et sans engagement pour expliquer le tarif et vérifier qu'il correspond à votre situation. 2) Nous planifions l'installation des panneaux et de la batterie et prenons en charge le contrôle par un organisme agréé. 3) Nous gérons automatiquement votre transfert. 4) Nous vous informons dès que votre contrat prend cours.",
      },
      {
        q: "Comment obtenir un devis ?",
        a: "Demandez un rendez-vous via le site. Nous inspectons votre toiture (orientation, sécurité), puis vous recevez un devis clair et transparent. Dès réception de l'acompte, nous nous mettons au travail.",
      },
      {
        q: "Qui s'occupe du contrôle et de la certification ?",
        a: "Nous nous en chargeons intégralement : installation des panneaux et/ou de la batterie, puis contrôle par un organisme agréé. C'est simple pour vous.",
      },
      {
        q: "Et si je change de fournisseur ou déménage ?",
        a: "Nous gérons tout le transfert de votre gaz et de votre électricité à votre place. Vous déménagez votre vie, nous transférons votre énergie.",
      },
    ],
  },
  {
    category: "Service & assistance",
    items: [
      {
        q: "L'assistante répond-elle dans ma langue ?",
        a: "Oui. L'assistante détecte automatiquement la langue de votre message et vous répond dans cette même langue, à tout moment.",
      },
      {
        q: "Comment prendre rendez-vous ?",
        a: "Choisissez un créneau dans la section Rendez-vous. Il est immédiatement ajouté à l'agenda de votre installateur et vous recevez une confirmation.",
      },
      {
        q: "Que faire en cas de panne de courant ?",
        a: "Une panne physique sur le réseau (travaux, coupure dans votre rue) relève de votre gestionnaire de réseau. Consultez son site web. Si vous disposez d'une batterie avec back-up, votre habitation continue de fonctionner.",
      },
    ],
  },
];

// Texte condensé fourni à l'assistante IA comme base de connaissances.
export const knowledgeBaseText = faqCategories
  .map(
    (c) =>
      `## ${c.category}\n` +
      c.items.map((i) => `Q: ${i.q}\nR: ${i.a}`).join("\n\n")
  )
  .join("\n\n");
